<template lang="pug">
  main.layout__main.pt-0
    section.clubs-intro.text-center(
      :style="{ backgroundImage: `url(${$getTenantImg('clubsIntro')})` }"
    )
      .clubs-intro__overlay.overlay
      .clubs-intro__content.container
        .grid.grid_h-center
          .grid__col.grid__col_lg-20
            .section__group.mt-0
              h1.heading Найдите клуб себе по&nbsp;душе
            .section__group
              form.search.block.block_wide(
                @submit.prevent="search"
              )
                .grid.grid_v-center.grid_v-margins
                  .grid__col.grid__col_md-stretch
                    .grid.grid_v-center.grid_v-margins
                      .grid__col.grid__col_24.grid__col_md-stretch.search__field
                        .field
                          .field__label
                            label.label Название
                          .field__input
                            .input
                              input.input__el(
                                v-model.trim="searchParams.name"
                                type="text"
                                placeholder="Как называется клуб?"
                                name="club_name"
                                autocomplete="off"
                              )
                              .input__icons
                                button.input__icon.input__icon_hover(
                                  type="button"
                                  v-show="searchParams.name"
                                  @click.prevent="searchParams.name = ''"
                                )
                                  icon(icon-name='close-circle-s')
                      .grid__col.grid__col_auto.d-none.d-md-block
                        .divider-v
                      .divider.d-md-none
                      .grid__col.grid__col_24.grid__col_md-stretch.search__field
                        .field
                          .field__label
                            label.label Спорт
                          .field__input
                            Select(
                              v-model="searchParams.discipline"
                              :value="searchParams.discipline"
                              :options="sportTypesFilterValues"
                              label="value"
                              placeholder="Выберите спорт"
                              type="simple"
                              size="md"
                              cls="multiselect_dropdown-auto"
                              :multiple="true"
                              :clearable="true"
                              open-direction="bottom"
                            )
                      .grid__col.grid__col_auto.d-none.d-md-block
                        .divider-v
                      .divider.d-md-none
                      .grid__col.grid__col_24.grid__col_md-stretch.search__field
                        .field
                          .field__label
                            label.label Местоположение
                          .field__input
                            Select(
                              v-model="searchParams.city"
                              :value="searchParams.city"
                              :options="citiesFilterValues"
                              placeholder="В каком городе?"
                              type="simple"
                              size="md"
                              cls="multiselect_dropdown-auto"
                              :clearable="true"
                              :searchable="true"
                              open-direction="bottom"
                            )
                      .divider.d-lg-none.transparent
                  .grid__col.grid__col_lg-auto
                    button.button.button_primary.button_lg.button_wide(
                      type="submit"
                      :class="{'button_loading': isSearching}"
                      :disabled="isSearching"
                    )
                      span.button__icon
                        icon(icon-name="search")
                      span.button__text Найти
                      span.button__icon.button__loading
                        icon(icon-name='loading')
            .section__group
              .section__item
                .heading-line
                  span.heading-line__text или
              .section__item
                router-link.button.button_white.button_lg(:to="{ name: 'CreateClub' }")
                  span.button__text Создать свой клуб
    .container#searchResults
      section.section.mt-0
        .section__group
          .section__header
            .grid.grid_v-center
              .grid__col.grid__col_auto
                h2.h3(style="min-width: 180px;")
                  span(v-html="searchResultTitle")
                  | &nbsp;
                  span.subtitle-2.color-muted {{ clubs.length ? `(${clubsCount})` : '' }}
              .grid__col.grid__col_auto.ml-auto.d-none.d-md-block
                label(style="user-select: none")
                  b.mr-8 Карта&nbsp;
                  Toggle(
                    v-model="showMap"
                    @change="saveMapVisibility"
                  )
            .section__subheader(:class="{'d-md-none': !showMap }")
              ClubsMap(
                ref="map"
                :searchString="searchParams.name"
                :sportTypes="searchParams.discipline"
                :city="searchParams.city"
                :show-map="showMap"
              )
                template(v-slot:top)
                  .d-md-none
                    label.grid.grid_v-center(style="user-select: none")
                      .grid__col.grid__col_stretch
                        b.mr-8 Карта&nbsp;
                      .grid__col.grid__col_auto
                        Toggle(
                          v-model="showMap"
                          @change="saveMapVisibility"
                        )
                    div(v-show="showMap" style="height: 16px;")
            .section__subheader
              Sort(
                :active="searchParams.sort"
                :order="searchParams.sortOrder"
                :options="sortOptions"
                :isDisabled="notFound"
                @change="changeSort"
              )
      section.section.mt-0
        .grid.grid_v-margins
          .grid__col.grid__col_md-12.grid__col_xl-8(v-for="club in clubs")
            ClubCard(
              :data="getClubData(club)"
              :isCompact="true"
              :key="club.code"
            )
        .loader(v-if="isLoading")
        InfiniteLoading(
          v-else
          :identifier="infiniteId"
          @infinite="infiniteLoader"
        )
          .loader(slot="spinner")
          div(slot="no-more")
          div(slot="no-results")
            .empty-state
              .section__group.mt-0
                .section__item Нет подходящих клубов под ваш запрос&nbsp;😔
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { scrollToId } from '@/assets/js/animation'
import { getSuffix } from '@/assets/js/helpers'
import clubsService from '../services/clubsService'
import Toggle from '@/components/Switch'
import Sort from '@/components/Sort'
import ClubCard from '@/components/ClubCard'
import ClubsMap from '@/components/ClubsMap'
import Select from '@/components/Select'
import InfiniteLoading from 'vue-infinite-loading'
import { isEqual, clone } from 'lodash'

export default {
  name: 'Clubs',
  components: {
    Toggle,
    Sort,
    ClubCard,
    ClubsMap,
    Select,
    InfiniteLoading
  },
  data () {
    return {
      searchResultTitle: null,
      searchParams: {
        name: null,
        discipline: [],
        city: null,
        sort: 'members',
        sortOrder: 'desc'
      },
      cityOptions: [],
      sortOptions: [
        {
          id: 'members',
          name: 'По&nbsp;числу участников',
          order: 'desc',
          reverse: true
        },
        {
          id: 'creation',
          name: 'Новые',
          order: 'desc'
        }
      ],
      settings: {
        page: 1,
        pageSize: 24
      },
      infiniteId: 0,
      isLoading: false,
      isLoaded: false,
      isSearching: false,
      getSuffix: getSuffix,
      showMap: false
    }
  },
  computed: {
    ...mapState('clubs', ['clubs', 'clubsCount', 'clubsSettings', 'clubsLoaded']),
    ...mapGetters('clubs', ['citiesFilterValues', 'sportTypesFilterValues']),
    hasFilters () {
      const params = this.searchParams
      return !!(params.name || params.city || (params.discipline && params.discipline.length))
    },
    notFound () {
      return !this.isLoading && this.isLoaded && !this.clubs.length
    }
  },
  methods: {
    ...mapActions('clubs', ['getClubs', 'getClubsFilters']),
    ...mapMutations('clubs', ['removeClubs', 'saveClubsSetting', 'setClubsLoadedStatus']),
    getClubData (data) {
      return {
        id: data.id,
        code: data.code,
        name: data.name,
        countryName: data.countryName,
        city: data.city,
        cityName: data.cityName,
        sportTypeIds: data.sportTypeIds,
        logoImage: data.logoImageUrl,
        membersCount: data.membersCount,
        isOnline: data.isOnline,
        clubPrivacy: data.clubPrivacy,
        isMember: data.isMember,
        isManager: data.isManager
      }
    },
    getSearchResultTitle () {
      const params = this.searchParams
      if (!params.name && !params.city && !params.discipline?.length) {
        return 'Все клубы'
      }
      let title = 'Клубы'

      if (params.name) {
        title += ` по запросу «${params.name}»`
      }

      if (params.discipline?.length) {
        const disciplines = params.discipline.reduce((result, id) => {
          const sport = this.sportTypesFilterValues.find((o) => o.id === id)
          if (sport) {
            result += `${sport.value.trim()}, `
          }
          return result
        }, '')
        title += ` с видом спорта «${disciplines.slice(0, -2)}»`
      }

      if (params.city) {
        title += ` в городе ${params.city}`
      }

      return title
    },
    loadClubs (infiniteState) {
      if (this.clubsLoaded) {
        if (infiniteState) {
          infiniteState.loaded()
          infiniteState.complete()
        }
        return
      }
      clubsService.cancelGettingClubs()
      this.settings.page = Math.floor(this.clubs.length / this.settings.pageSize) + 1
      this.getClubs({
        page: this.settings.page,
        pageSize: this.settings.pageSize,
        searchString: this.searchParams.name,
        sportTypes: this.searchParams.discipline,
        city: this.searchParams.city,
        sortBy: this.searchParams.sort,
        sortOrder: this.searchParams.sortOrder
      })
        .then(() => {
          if (this.clubs.length === 0) {
            infiniteState && infiniteState.complete()
          } else {
            infiniteState && infiniteState.loaded()
            if (this.clubs.length - this.settings.page * this.settings.pageSize < 0) {
              infiniteState && infiniteState.complete()
              this.setClubsLoadedStatus(true)
            }
          }
          if (this.isLoading) {
            scrollToId('searchResults')
          }
          this.isLoaded = true
          this.isLoading = false
          this.isSearching = false
          this.searchResultTitle = this.getSearchResultTitle()
        })
        .catch(response => {
          if (response.message !== 'canceled') {
            infiniteState && infiniteState.complete()
            this.isLoading = false
            this.isSearching = false
          }
        })
    },
    infiniteLoader ($state) {
      this.loadClubs($state)
    },
    filterClubs () {
      const isChanged = !isEqual(this.searchParams, this.clubsSettings)
      if (!isChanged) {
        this.isSearching = false
        return
      }

      const needUpdateMap = !isEqual({
        name: this.searchParams.name,
        discipline: this.searchParams.discipline,
        city: this.searchParams.city
      }, {
        name: this.clubsSettings.name,
        discipline: this.clubsSettings.discipline,
        city: this.clubsSettings.city
      })

      this.setQuery()
      this.saveClubsSetting(clone(this.searchParams))
      this.removeClubs()
      this.setClubsLoadedStatus(false)
      this.loadClubs()
      this.setMapVisibility()
      this.isLoading = true

      if (needUpdateMap) {
        this.$refs.map.update()
      }
    },
    parseQuery () {
      const query = this.$route.query
      const sort = query.sort && query.sort.split('_')

      if (sort) {
        this.searchParams.sort = sort[0] || 'creation'
        this.searchParams.sortOrder = sort[1] || null
      }

      if (query.q) {
        this.searchParams.name = query.q
      }

      if (query.disciplines) {
        this.searchParams.discipline = Array.isArray(query.disciplines) ? query.disciplines : [query.disciplines]
      }

      if (query.city) {
        this.searchParams.city = query.city
      }

      this.saveClubsSetting(clone(this.searchParams))
    },
    setQuery () {
      const query = {}
      query.sort = this.searchParams.sort + (this.searchParams.sortOrder ? '_' + this.searchParams.sortOrder : '')

      if (this.searchParams.name) {
        query.q = this.searchParams.name
      }

      if (this.searchParams.discipline) {
        query.disciplines = this.searchParams.discipline
      }

      if (this.searchParams.city) {
        query.city = this.searchParams.city
      }

      this.$router.replace({
        query: query
      })
    },
    search () {
      if (this.isSearching) {
        return
      }
      this.isSearching = true
      this.filterClubs()
    },
    changeSort (value) {
      this.searchParams.sort = value.id
      this.searchParams.sortOrder = value.order
      this.isSearching = false
      this.filterClubs()
    },
    setMapVisibility () {
      const savedState = JSON.parse(localStorage.getItem('rr_clubs_map_shown'))
      if (savedState !== null) {
        this.showMap = savedState
        return
      }
      this.showMap = !this.hasFilters
    },
    saveMapVisibility () {
      localStorage.setItem('rr_clubs_map_shown', JSON.stringify(this.showMap))
    }
  },
  mounted () {
    this.getClubsFilters()
    this.parseQuery()
    this.loadClubs()
    this.setMapVisibility()
  }
}
</script>

<style lang="scss" scoped>
  .clubs-intro {
    position: relative;
    padding-top: 48px;
    padding-bottom: 48px;
    color: $color-white;
    background-size: cover;
    background-position: center;

    @media (min-width: breakpoint(lg)) {
      padding-top: 64px;
      padding-bottom: 64px;
    }

    &__overlay {
      background: $gradient-horizontal-primary-light;
    }

    &__content {
      position: relative;
      z-index: 1;
    }
  }

  .search {
    padding: 16px;

    @media (min-width: breakpoint(lg)) {
      padding-left: 20px;
    }

    &__field {
      width: 30%;
      margin-top: -4px;
    }

    .input {
      padding: 0;

    }
    .input__el {
      height: 24px;
      padding-left: 0;
    }

    .input__icons {
      padding-right: 0;
      margin-right: -6px;
    }

    .input__icon {
      padding-top: 2px;
      padding-bottom: 2px;
    }

    .divider-v {
      height: 48px;
    }
  }
</style>

<style lang="scss">
  .city-select {

    .vue-treeselect__control {
      border-color: transparent !important;
      box-shadow: none !important;
    }

    .vue-treeselect__control-arrow-container {
      display: none;
    }
  }
</style>
